module.exports = __webpack_public_path__ + "img/Burkina Faso.3268425e.svg";